import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=e482fd8e&scoped=true"
import script from "./SectionTitle.ts?vue&type=script&lang=ts&external"
export * from "./SectionTitle.ts?vue&type=script&lang=ts&external"
import style0 from "./SectionTitle.scss?vue&type=style&index=0&id=e482fd8e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e482fd8e",
  null
  
)

export default component.exports